// Callback.jsx
import { useEffect } from "react";
import { exchangeCodeForToken } from "../Services/SpotifyAuth";

export default function Callback() {
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const code = p.get("code");
    const state = p.get("state");
    const error = p.get("error");

    (async () => {
      if (error) throw new Error(error);
      if (!code || !state) throw new Error("Missing code/state");
      await exchangeCodeForToken(code, state);

      // rensa query + gå hem
      window.location.replace("/");
    })().catch((e) => {
      console.error(e);
      window.location.replace("/");
    });
  }, []);

  return <div>Logging in…</div>;
}
